export const isUserLoggedIn = (state: any): boolean => state.app.auth.isLoggedIn;
export const isModalOpened = (state: any): boolean => state.app.modalData !== undefined;
export const getShowLoadSpinner = (state: any): boolean => state.app.showLoaderSpinner;
